import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b9d6fb4e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9d6fb4e')) {
      api.createRecord('b9d6fb4e', component.options)
    } else {
      api.reload('b9d6fb4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b9d6fb4e", function () {
      api.rerender('b9d6fb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/bodyclass/index.vue"
export default component.exports